import React, { useState } from 'react';
import { Button, Col, message, Row } from 'antd';

import { addDevelopAccount } from '@services/cstool/develop-account';

import AddDevelopAccountModal from './components/modal/add-develop-account';

export default function DevelopAccountPageBody() {
  const [isAddDevelopAccountModalVisible, setIsAddDevelopAccountModalVisible] = useState(false);

  const handleAddDevelopAccount = (userId: string, environment: string) => {
    addDevelopAccount(userId, environment)
      .then(() => {
        message.success(
          `Develop account added successfully for user ${userId} in environment ${environment}`,
        );
      })
      .finally(() => {
        setIsAddDevelopAccountModalVisible(false);
      });
  };

  return (
    <div className="flex flex-col flex-1 max-h-full min-h-full p-4">
      <Row justify="space-between" className="mb-4">
        <Col>
          <Button type="primary" onClick={() => setIsAddDevelopAccountModalVisible(true)}>
            Add Develop Account
          </Button>
        </Col>
      </Row>
      <AddDevelopAccountModal
        isOpen={isAddDevelopAccountModalVisible}
        setIsOpen={setIsAddDevelopAccountModalVisible}
        onSuccess={handleAddDevelopAccount}
      />
    </div>
  );
}
